export const sourceRegistry = {
  goodJobsFirstParent: {
    label: "Good Jobs First Violation Tracker: Mutual of Omaha parent summary",
    href: "https://violationtracker.goodjobsfirst.org/parent/mutual-of-omaha",
    type: "Regulatory database summary",
  },
  goodJobsFirstMassachusetts2025: {
    label: "Good Jobs First Violation Tracker: Massachusetts 2025 Mutual of Omaha Mortgage record",
    href: "https://violationtracker.goodjobsfirst.org/violation-tracker/ma-mutual-of-omaha-mortgage-inc-0",
    type: "Regulatory database record",
  },
  massachusettsConsentOrder2025: {
    label: "Massachusetts Division of Banks consent order: Mutual of Omaha, April 14, 2025",
    href: "https://www.mass.gov/consent-order/consent-order-mutual-of-omaha-april-14-2025",
    type: "Agency consent order",
  },
  goodJobsFirstSouthCarolina2025: {
    label: "Good Jobs First Violation Tracker: South Carolina 2025 Mutual of Omaha Insurance Company record",
    href: "https://violationtracker.goodjobsfirst.org/violation-tracker/sc-mutual-of-omaha-insurance-company",
    type: "Regulatory database record",
  },
  southCarolinaDoiPdf2025: {
    label: "South Carolina Department of Insurance order: Mutual of Omaha Insurance Company",
    href: "https://doi.sc.gov/DocumentCenter/View/14979/Mutual-of-Omaha-Ins-Co",
    type: "Agency PDF",
  },
  southDakotaConsentOrder2024: {
    label: "South Dakota Division of Insurance consent order: United of Omaha Life Insurance Company",
    href: "https://dlr.sd.gov/insurance/admin_actions/documents/2024/united_of_omaha_life_insurance_company.pdf",
    type: "Agency PDF",
  },
  goodJobsFirstSouthDakota2024: {
    label: "Good Jobs First Violation Tracker: South Dakota 2024 United of Omaha Life Insurance Company record",
    href: "https://violationtracker.goodjobsfirst.org/violation-tracker/sd-united-of-omaha-life-insurance-company",
    type: "Regulatory database record",
  },
  goodJobsFirstConnecticut2008: {
    label: "Good Jobs First Violation Tracker: Connecticut 2008 Mutual of Omaha Insurance Co. record",
    href: "https://violationtracker.goodjobsfirst.org/violation-tracker/ct-mutual-of-omaha-insurance-co",
    type: "Regulatory database record",
  },
  robShellOfficial: {
    label: "Mutual of Omaha Mortgage loan officer page: Rob Shell",
    href: "https://www.mutualmortgage.com/loan-officer/rshell/",
    type: "Company profile",
  },
  robShellLinkedIn: {
    label: "LinkedIn profile: Robert Hillman Shell",
    href: "https://www.linkedin.com/in/rob-shell-93622325/",
    type: "Public profile",
  },
  tonyFragaleOfficial: {
    label: "Mutual of Omaha Mortgage loan officer page: Tony Fragale",
    href: "https://www.mutualmortgage.com/loan-officer/tfragale/",
    type: "Company profile",
  },
  mackenzieCurtisOfficial: {
    label: "Acrisure Mortgage public profile: Mackenzie Curtis, NMLS 471956",
    href: "https://acrisuremortgage.com/mcurtis/",
    type: "Current company profile",
  },
  mutualMortgageHome: {
    label: "Mutual of Omaha Mortgage homepage and licensing footer",
    href: "https://www.mutualmortgage.com/",
    type: "Company website",
  },
  mutualMortgageBrentwood: {
    label: "Mutual of Omaha Mortgage Brentwood, Tennessee location page",
    href: "https://www.mutualmortgage.com/about-us/locations/brentwood-tn/",
    type: "Company location page",
  },
  bbbMutualMortgageComplaints: {
    label: "BBB complaints: Mutual of Omaha Mortgage",
    href: "https://www.bbb.org/us/il/lombard/profile/mortgage-lenders/mutual-of-omaha-mortgage-0654-90027033/complaints",
    type: "Consumer complaint source",
  },
  bbbMutualMortgageComplaintsPageThree: {
    label: "BBB complaints page 3: Mutual of Omaha Mortgage",
    href: "https://www.bbb.org/us/il/lombard/profile/mortgage-lenders/mutual-of-omaha-mortgage-0654-90027033/complaints?page=3",
    type: "Consumer complaint source",
  },
  trustpilotMutualMortgageReviews: {
    label: "Trustpilot reviews: Mutual of Omaha Mortgage",
    href: "https://www.trustpilot.com/review/www.mutualmortgage.com",
    type: "Consumer review source",
  },
  bankrateMutualMortgageReview: {
    label: "Bankrate review: Mutual of Omaha Mortgage",
    href: "https://www.bankrate.com/mortgages/reviews/mutual-of-omaha-mortgage/",
    type: "Mortgage review",
  },
  truthAboutMortgageMutualMortgageReview: {
    label: "The Truth About Mortgage review: Mutual of Omaha Mortgage",
    href: "https://www.thetruthaboutmortgage.com/mutual-of-omaha-mortgage-review/",
    type: "Mortgage review",
  },
  longbridgeJustiaOrder2025: {
    label: "Justia: Longbridge Financial v. Mutual of Omaha Mortgage, preliminary injunction order",
    href: "https://law.justia.com/cases/federal/district-courts/california/casdce/3%3A2024cv01730/794539/43/",
    type: "Federal court order",
  },
  longbridgeComplaintPdf2024: {
    label: "Longbridge complaint PDF against Mutual of Omaha Mortgage",
    href: "https://www.thewbkfirm.com/wp-content/uploads/Longbridge-Complaint.pdf",
    type: "Federal court complaint PDF",
  },
  longbridgeCchOrderPdf2025: {
    label: "CCH PDF mirror: Longbridge v. Mutual of Omaha Mortgage order",
    href: "https://business.cch.com/ald/LongbridgeFinancialLLCvMutualofOmahaMortgageInc5142025.pdf",
    type: "Federal court order PDF",
  },
  housingWireLongbridgeSettlement2026: {
    label: "HousingWire: Longbridge and Mutual of Omaha settlement report",
    href: "https://www.housingwire.com/articles/longbridge-mutual-omaha-settlement/",
    type: "Mortgage industry reporting",
  },
  housingWireLongbridgeDismissal2026: {
    label: "HousingWire: Longbridge and Mutual of Omaha move to dismiss lawsuit",
    href: "https://www.housingwire.com/articles/longbridge-mutual-of-omaha-reverse-mortgage-marketing-lawsuit/",
    type: "Mortgage industry reporting",
  },
  baeselJustiaOrder2020: {
    label: "Justia: Baesel v. Mutual of Omaha Mortgage TCPA case",
    href: "https://law.justia.com/cases/federal/district-courts/california/casdce/3%3A2020cv00886/675415/35/",
    type: "Federal court order",
  },
  vickiSmithLinkedIn: {
    label: "LinkedIn profile: Vicki Smith, PulteGroup New Home Sales Consultant",
    href: "https://www.linkedin.com/in/vicki-smith-davidweekleyhomes/",
    type: "Public profile",
  },
  homesSorenUnit303: {
    label: "Homes.com / Realtracs record: 700 N Dupont Ave Unit 303",
    href: "https://www.homes.com/property/700-n-dupont-ave-madison-tn-unit-303/b5dt75334mmgd/",
    type: "Real estate listing record",
  },
  pulteGroupLinkedIn: {
    label: "PulteGroup LinkedIn company profile",
    href: "https://www.linkedin.com/company/4884/",
    type: "Company profile",
  },
  pulteTennesseeLinkedIn: {
    label: "PulteGroup Tennessee Division LinkedIn page",
    href: "https://www.linkedin.com/showcase/pultegroup-tennessee-division/",
    type: "Company division profile",
  },
  fox5PulteDelWebb2026: {
    label: "FOX5 Las Vegas: Lake Las Vegas homeowners ordered to arbitration in construction defect lawsuit",
    href: "https://www.fox5vegas.com/2026/05/16/lake-las-vegas-homeowners-ordered-arbitration-construction-defect-lawsuit/",
    type: "News report",
  },
  cfpbComplaintPortal: {
    label: "Consumer Financial Protection Bureau complaint portal",
    href: "https://www.consumerfinance.gov/complaint/",
    type: "Regulator portal",
  },
  submittedComplaintPublicCopy: {
    label: "Complete submitted complaint dated November 8, 2025",
    href: "https://mutualmortgagee.com/",
    type: "Owner-supplied complaint record with limited protected-field omissions",
    limitation:
      "No complaint-specific public CFPB record URL is available. The complete substantive complaint text is published; only protected identity, signature, contact, and non-central private-address fields are withheld, and private correspondence is summarized.",
    correctionNote:
      "Owner-supplied correction recorded October 15, 2026: the alleged offered rate was approximately 10 percent, and the complainant states that a rate buydown was required.",
  },
  regulationZ: {
    label: "CFPB Regulation Z, 12 CFR Part 1026",
    href: "https://www.consumerfinance.gov/rules-policy/regulations/1026/",
    type: "Federal regulation",
  },
  nmlsConsumerAccess: {
    label: "NMLS Consumer Access",
    href: "https://www.nmlsconsumeraccess.org/",
    type: "Licensing lookup",
  },
};

export function pickSources(keys) {
  return keys.map((key) => sourceRegistry[key]).filter(Boolean);
}

export const sourceCollections = {
  mutualRegulatoryRecords: pickSources([
    "goodJobsFirstParent",
    "goodJobsFirstMassachusetts2025",
    "massachusettsConsentOrder2025",
    "goodJobsFirstSouthCarolina2025",
    "southCarolinaDoiPdf2025",
    "goodJobsFirstSouthDakota2024",
    "southDakotaConsentOrder2024",
    "goodJobsFirstConnecticut2008",
  ]),
  peopleAndEntities: pickSources([
    "robShellOfficial",
    "robShellLinkedIn",
    "tonyFragaleOfficial",
    "mackenzieCurtisOfficial",
    "mutualMortgageHome",
    "mutualMortgageBrentwood",
    "vickiSmithLinkedIn",
    "homesSorenUnit303",
    "pulteGroupLinkedIn",
    "pulteTennesseeLinkedIn",
  ]),
  publicMortgageComplaints: pickSources([
    "bbbMutualMortgageComplaints",
    "bbbMutualMortgageComplaintsPageThree",
    "trustpilotMutualMortgageReviews",
    "bankrateMutualMortgageReview",
    "truthAboutMortgageMutualMortgageReview",
  ]),
  mutualMortgageCourtRecords: pickSources([
    "longbridgeJustiaOrder2025",
    "longbridgeComplaintPdf2024",
    "longbridgeCchOrderPdf2025",
    "housingWireLongbridgeSettlement2026",
    "housingWireLongbridgeDismissal2026",
    "baeselJustiaOrder2020",
  ]),
  builderAndPulte: pickSources([
    "homesSorenUnit303",
    "pulteGroupLinkedIn",
    "pulteTennesseeLinkedIn",
    "fox5PulteDelWebb2026",
  ]),
};
